import { Changeset } from 'ember-changeset';
import { BufferedChangeset } from 'ember-changeset/types';
import { IDashboardWidgetWithComponent } from 'volta/models/types/user';

import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

interface IArgs {
  widget: IDashboardWidgetWithComponent;
  onUpdate: (widget: IDashboardWidgetWithComponent) => void;
}

export default class WidgetEditorTableauReport extends Component<IArgs> {
  @tracked widgetArgs = this.args.widget.args ?? {};
  @tracked argChangeset!: BufferedChangeset;

  constructor(owner: any, args: IArgs) {
    super(owner, args);
    this.initChangeset();
  }

  @action
  updateWidget(): void {
    this.argChangeset.validate();

    if (this.argChangeset.isValid) {
      this.argChangeset.execute();
      this.args.onUpdate({ ...this.args.widget, args: this.widgetArgs });
    }
  }

  @action
  initChangeset() {
    this.argChangeset = Changeset(this.widgetArgs);
  }
}
